import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

const ExpSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const selectedExp = useSelector((state) => state.playersAndTeams.filter.values.isRookie);

    const setExp = (e, { value }) => {
        dispatch(filterActionCreators.setExperience(value));
    };

    const options = [
        {
            value: '',
            label: `${intl.formatMessage(commonMessages.experienceValues['1'])} + ${intl.formatMessage(commonMessages.experienceValues['0'])}`,
            key: 'both',
        },
        {
            value: '1',
            label: intl.formatMessage(commonMessages.experienceValues['1']),
            key: '1',
        },
        {
            value: '0',
            label: intl.formatMessage(commonMessages.experienceValues['0']),
            key: '0',
        },
    ];

    return (
        <Select
            onOptionChange={setExp}
            options={options}
            selectedOption={options.find((obj) => obj.value === selectedExp)}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(ExpSelect);
